import { FieldDecimal, Text } from 'bz-core-controls';
import FieldSelect from 'bz-core-controls/controls/form/field/field-select';
import React from 'react';

const neverField = '__never__';
const neverOperator = 'never';

class GroupAttributes extends React.Component {
  constructor(props) {
    super(props);
    this.schema = this.props.store.onSchema();
    this.state = this.onLoad(props.field);
  }

  UNSAFE_componentWillReceiveProps(props) {
    let { field } = props;
    if (field === this.props.field) {
      return;
    }
    this.setState(this.onLoad(field));
  }

  render() {
    let input;
    let { operators, control } = this.state;
    let { field, operator, operatorValue, store, rangeFrom, rangeTo } = this.props;
    const isNever = field === neverField || operator === neverOperator;

    let fields = [{ name: 'Never', field: neverField }];

    Object.keys(this.schema).map((x, i) => {
      let item = this.schema[x];
      if (item.label != x) fields.push({ name: item.label || x, field: x });
    });
    if (!!control && !isNever) {
      let newProps = Object.assign({}, this.schema[field].extraProps, {
        value: operatorValue,
        onChange: this.onChange.bind(this)
      });
      // change behaviour of value selector a little...
      newProps.warning = true;
      newProps.inline = true;
      newProps.required = false;
      newProps.lists = store.lists;
      newProps.cache = store.cache;
      newProps.lookups = store.lookups;
      newProps.searches = store.searches;
      newProps['text-if-no'] = false;
      newProps['text-if-yes'] = false;

      let _control = store.controls[control].control;
      let Control = _control.default ? _control.default : _control;
      if (control === 'Formula') {
        input = <Text {...newProps} />;
      } else {
        input = <Control {...newProps} />;
      }
      if (this.props.operator == '><' || this.props.operator == '>=<=') {
        input = (
          <div className="flex-row">
            <FieldDecimal
              maxLength={25}
              label={'X'}
              value={rangeFrom}
              onChange={this.onRangeChange.bind(this, 'rangeFrom')}
            />
            <FieldDecimal
              maxLength={25}
              label={'Y'}
              value={rangeTo}
              onChange={this.onRangeChange.bind(this, 'rangeTo')}
            />
          </div>
        );
      }
    } else {
      input = <span>N/A</span>;
    }

    return (
      <div>
        <div className="attribute">
          <div>
            <h4>Show when</h4>
            <FieldSelect
              value={field}
              items={fields}
              includeNone={false}
              warning={true}
              valueMember="field"
              displayMember="name"
              onChange={this.onFieldSelect.bind(this)}
            />
            {!isNever && (
              <div style={{ marginLeft: 10, color: '#666', fontSize: 11 }}>
                <i className="fa fa-info-circle" /> If your field isn&apos;t appearing in the list,
                make sure it has a name on its property page
              </div>
            )}

            {!isNever && (
              <FieldSelect
                includeNone={false}
                value={operator}
                items={operators}
                warning={true}
                valueMember="value"
                displayMember="label"
                onChange={this.onSelect.bind(this, 'operator')}
              />
            )}
            {!isNever && input}
          </div>
        </div>
      </div>
    );
  }

  onLoad(field) {
    let details = this.schema[field || ''];

    if (!details) {
      return { type: null, control: null, operators: [] };
    }

    let operators = [
      { label: 'Is', value: '=' },
      { label: 'Isnt', value: '!' }
    ];

    if (details.type === 'number' || details.control === 'Formula') {
      operators.push({ label: 'Is Less Than', value: '<' });
      operators.push({ label: 'Is More Than', value: '>' });
      operators.push({ label: '>x and <y', value: '><' });
      operators.push({ label: '>=x and <=y', value: '>=<=' });
    }
    if (details.type === 'array' || (details.extraProps && details.extraProps.multi)) {
      operators = [];
      operators.push({ label: 'Has', value: '|' });
      operators.push({ label: "Hasn't", value: '^' });
    }

    return {
      type: details.type,
      control: details.control,
      operators: operators
    };
  }

  onFieldSelect(e: any) {
    const field = e.target.value;

    if (field === neverField) {
      this.props.onMultiChange({
        field: neverField,
        fieldName: 'Never',
        operator: neverOperator,
        operatorValue: neverOperator
      });
      return;
    }

    this.props.onMultiChange({
      field,
      fieldName: this.schema[field].label,
      operator: undefined,
      operatorValue: undefined,
      rangeFrom: undefined,
      rangeTo: undefined
    });
  }

  onSelect(key, e) {
    this.props.onChange(key, e.target.value);
  }

  onChange(val) {
    let { type } = this.state;
    // possibly parse bool
    // if (type === 'number') { val = parseFloat(val) }
    if (type === 'date') {
      val = val.toString();
    }
    this.props.onChange('operatorValue', val);
  }

  async onRangeChange(key, e) {
    await this.props.onChange(key, e);

    if (this.props.rangeFrom && this.props.rangeTo) {
      let val =
        parseFloat(this.props.rangeFrom.replace(',', '')) +
        'and' +
        parseFloat(this.props.rangeTo.replace(',', ''));
      this.props.onChange('operatorValue', val);
    }
  }
}

export default GroupAttributes;
